import { render, staticRenderFns } from "./SurgeryReport.vue?vue&type=template&id=33474162&scoped=true&"
import script from "./SurgeryReport.vue?vue&type=script&lang=js&"
export * from "./SurgeryReport.vue?vue&type=script&lang=js&"
import style0 from "./SurgeryReport.vue?vue&type=style&index=0&id=33474162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33474162",
  null
  
)

export default component.exports